var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "redo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/redo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "redo_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2467 12.7067H5.91341C4.07341 12.7067 2.58008 11.2134 2.58008 9.37337C2.58008 7.53337 4.07341 6.04004 5.91341 6.04004H13.2467",
    stroke: "#D1D0E1",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.7134 7.70667L13.42 6L11.7134 4.29333",
    stroke: "#D1D0E1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.b26124cfbb3b96a1618f04f5dcb2e4d1.svg";
export { ForwardRef as ReactComponent };